import { FlowStep } from '../interfaces';

export default (flowStep?: FlowStep): boolean => {
    return flowStep?.requireAuthentication === true;
};
